import { getConditionsFilterConfig } from '../filters/condition';
import { getSizeFilterConfig } from '../filters/size';
import { getDefaultShopConfig } from './default';
import * as custom from '../filters/marketplace-custom-config';
import { getBrandDirectFilterConfig } from '../filters/brandDirect';

const senitaathleticsSizes = ['XXS', 'XS', 'S', 'M', 'L', 'XL', 'XXL'];

const senitaathleticsAdditionalPayoutSettings = {
  additionalShopifyGiftCardRequirements: {
    giftCardExpiresAfterDays: 365, // 1 year
  },
  creditCodeHelperText: 'Gift card expires 1 year after date of issue.',
};

export const senitaathleticsShopConfig = {
  ...getDefaultShopConfig(),
  filters: [
    ...custom.filters,
    getConditionsFilterConfig(),
    getBrandDirectFilterConfig(),
    getSizeFilterConfig({
      sizes: senitaathleticsSizes,
    }),
  ],
  additionalPayoutSettings: senitaathleticsAdditionalPayoutSettings,
};
